<template>
    <div class="w-full rounded overflow-hidden mb-auto">
        <OpportunitiesChart />
        <div class="p-4 bg-white w-full lg:border-b border-gray-200">
            <h3 class="font-bold text-xl page-title">{{ $__('opportunities.table_title') }}</h3>
        </div>
        <TableContent :opportunities="opportunities" />
        <TableShowMoreFoot/>
    </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3';
import TableShowMoreFoot from "@/Components/Opportunities/Table/Content/ShowMoreFoot";
import TableContent from "@/Components/Opportunities/Table/Content/Index";
import OpportunitiesChart from "@/Components/OpportunitiesChart";

export default {
    props: ['opportunities'],
    components: {
        OpportunitiesChart,
        Link,
        TableShowMoreFoot,
        TableContent,
    }
}

</script>
